// import { get } from 'lodash';

export const Path = {
  updateService: 'service',
  fetchPublicServiceById: 'service/public',
  providerService: 'service/providerService',
  sendlocation: 'service/getstates',
  getSearchResult: 'service/',
  conciergeSearch: 'service/conciergeSearch',
  searchSuggestions: 'service/searchSuggestions',
  prowlCategoryCounts: 'service/public/prowl/category-counts',
  prowlFacetCount: 'service/public/prowl/facet-count',
  getAllSubCategory: 'subCategory',
  getAllCategory: 'category',
  getAllCategoryAndSub: 'category/categoryAndSub',
  checkBookingAvailability: 'booking/availability',
  reviews: '/reviews',
  favorite: '/favorite',
  //addFavorite
  addFavorite: 'addFavorite',
  serviceSuggestions: 'service/suggestions',
  allServicebyQuery: 'service/all',
  servicebyQuery: 'service/public/search',
  allPublicServiceByProvider: 'service/public/all',

  // Password reset (unauthenticated — forgot password flow)
  requestPasswordResetVerifyCode: '/auth/forgotPassword',
  submitResetPasswordVerifyCode: '/auth/resetPassword',
  submitResetPasswordPayload: '/auth/resetPassword',
  resendCode: '/auth/resendCode',

  // Change password (authenticated)
  changePassword: '/auth/changePassword',
  changePasswordRequestOtp: '/auth/changePassword/requestOtp',
  changePasswordResendOtp: '/auth/changePassword/resendOtp',
  changePasswordVerifyOtp: '/auth/changePassword/verifyOtp',

  bookings: 'booking',
  getStaff: 'staff',
  getProvider: 'user',
  // Two-Factor Authentication endpoints
  mfaStatus: 'auth/mfa',
  mfaAssociate: 'auth/mfa/totp/associate',
  mfaVerify: 'auth/mfa/totp/verify',
  mfaDisable: 'auth/mfa/disable',
  mfaRecoveryCodes: 'auth/mfa/recovery-codes',
  mfaRecoverLogin: 'auth/recoverLogin',
  // Email-based 2FA endpoints
  sendEmail2FA: 'auth/2fa/send-email',
  verifyEmail2FA: 'auth/2fa/verify-email',
  check2FAStatus: 'auth/2fa/status',
  disable2FA: 'auth/2fa/disable',
  // Account deletion/reactivation endpoints
  // deleteRequest: '/user/deleteRequest/:userId',
  deleteConfirmed: '/user/deleteConfirmed/:userId',
  reactivateRequest: '/user/reactivateRequest/:userId',
  reactivateConfirm: '/user/reactivateConfirm/:userId',

  // VITE_APP_BACKEND_USER=/user/api/v2

  // deleteRequest: 'accounts/deactivate/request',
  resendVerificationCode: 'accounts/resend/otp',
  reActivateAccount: 'accounts/reactivate',

  // DELETE ACCOUT
  deleteRequest: 'accounts/delete/initiate',
  verifyDeleteOtp: 'accounts/delete/verify',

  // DEACTIVATE ACCOUNT
  deactivateRequest: 'accounts/deactivate/request',
  verifyDeactivateOtp: 'accounts/deactivate/verify',

  resendOtpForAccount: 'accounts/resend/otp',
  reactivateAccount: 'accounts/reactivate',

  // getAllSubCategory: '/subCategory',
  // getAllCategory: '/category',
  // getAllCategoryAndSub: '/category/categoryAndSub',
  // getAllSubCategory: 'subCategory',
  // getAllCategory: 'category',
  // getAllCategoryAndSub: 'category/categoryAndSub',
  // checkBookingAvailability: 'booking/checkAvailability',
  // checkTimeslotAvailable: 'booking/checkAvailableStaffForTimeSlot',

  checkTimeslotAvailable: 'booking/checkAvailableStaffForTimeSlot',
  totalCalculation: 'booking/calculateTotals',
  verifyPromoCode: 'packAndDis/checkPromoCode',

  getProviderServiceById: 'service/provider',
  getPublicServiceByProviderId: 'service/public/all',

  addUserAddress: 'user/:id/address',
  removeUserAddress: 'user/:id/address/:addressId',

  getUserById: 'user/:id',
  getUserByIds: 'user/getUsers',

  getProviderJobCard: 'jobcard',

  businessSettingsGet: '/provider-meta/provider/:providerId',

  getAllJobCardByProviderId: '/jobcard',

  // certificate:
  //   'user/api/v1/certificates?q=isShowProfile&page=1&limit=20&sort=-createdAt',
  certificate: '/certificates',

  becomaAProvider: 'user/becomeAProvider/:id',

  getProviderDetailsBySlug: 'user/by-slug/:slug',

  // Business endpoints (Phase 1 multi-business support — per §5.5)
  getBusinessBySlug: 'business/by-slug/:businessSlug',
  getPublicServicesByBusiness: 'service/public/all',
  businessPublicStats: '/booking/public/business-stats/:businessId',

  // Support Ticket endpoints
  createSupportTicket: 'helpcenter/createTicket',
  getTicketsByEmail: 'helpcenter/getTicketsByEmail',

  // getStaff: 'staff',
  // getProvider: 'user',

  reverseGeocode: 'geoLocation/reverse-geocode',
  autoComplete: 'geoLocation/autocomplete',
  getLandingPage: 'bff/v1/landing',
  membership: '/payment/api/v1/membership',
  membershipCreateSubscription:
    '/payment/api/v1/membership/create-subscription',
  // Booking Dashboard endpoints
  taxCalculation: '/payment/api/v1/tax/calculate',
  // getBookings: 'service/api/v1/booking/customer/bookings',
  getBookings: '/booking/customer/bookings',
  bookingStatus: 'booking/:id/status',
  bookingAnalytics: '/booking/analytics/counts',
  providerPublicStats: '/booking/public/provider-stats/:providerId',
  bookingGetByQuery: '/booking/all',
  // bookingByStatus: "api/v1/booking/provider/bookings",
  // getBookings: 'product/api/v1/booking', --------old one

  getBookingById: '/booking/:bookingId',
  getBookingByReference: '/booking/referenceCode/:referenceCode',
  getConfirmedBookings: '/booking/confirmed',

  // Provider-created booking acceptance (customer-facing pay page)
  bookingAccept: '/booking/:bookingId/accept',
  bookingDecline: '/booking/:bookingId/decline',

  // ── Phase 2: Quote-based booking (Job vertical) ─────────────────────────
  jobCreate: '/job',
  jobListCustomer: '/job/customer',
  jobDetail: '/job/:jobId',
  jobAccept: '/job/:jobId/accept',
  jobDecline: '/job/:jobId/decline',
  jobCancel: '/job/:jobId/cancel',
  jobConfirmCompletion: '/job/:jobId/confirm-completion',
  jobBroadcastAccept: '/job/broadcast/:batchId/accept',
  jobRequestChanges: '/job/:jobId/request-changes',
  jobCancelRequestChanges: '/job/:jobId/cancel-request-changes',
  jobRevisions: '/job/:jobId/revisions',
  jobThread: '/job/:jobId/thread',
  jobThreadMessages: '/job/:jobId/thread/messages',
  jobThreadAttachments: '/job/:jobId/thread/attachments',

  // ── Phase 3: Package-based booking (CustomerPackage vertical) ───────────
  customerPackagePurchase: '/customer-package/purchase',
  customerPackageListCustomer: '/customer-package/customer',
  customerPackageAutoRenew: '/customer-package/:customerPackageId/auto-renew',
  customerPackageBookSession:
    '/customer-package/:customerPackageId/book-session',
  customerPackageAccept: '/customer-package/:customerPackageId/accept',
  customerPackageDecline: '/customer-package/:customerPackageId/decline',
  customerPackageCancel: '/customer-package/:customerPackageId/cancel',

  // Booking online payment (gigmosaic-payment-service). Creates a Stripe
  // PaymentIntent (capture_method: manual) and returns its clientSecret.
  // Note the plural `/payments/pay` — it must match the payment-service route.
  paymentIntent: '/payment/api/v1/payments/pay',

  // Google Calendar integration (customer-facing)
  googleCalendarAuth: 'google-calendar/auth',
  googleCalendarStatus: 'google-calendar/status',
  googleCalendarDisconnect: 'google-calendar/disconnect',
  googleCalendarSync: 'google-calendar/sync',

  createNewConversation: 'api/chat/createNewConversation',

  // Notification endpoints
  getNotifications: 'notification/api/web-notification/:userId/:role',
  getUnreadNotifications:
    'notification/api/web-notification/getunread/:userId/:role',
  markNotificationAsRead: 'notification/api/web-notification',
  markAllNotificationsAsRead:
    'notification/api/web-notification/mark-all/:userId/:role',
  deleteNotification: 'notification/api/web-notification/:userId',

  // FAQ endpoints
  faqSearch: 'bot/api/v1/faq/search',
  faqAiSearch: 'bot/api/v1/faq/ai-search',
  faqCategory: 'bot/api/v1/faq/category',

  // Referral endpoints
  trackReferralCode: 'referral/track',

  // Auth service: PATCH session provider portal onboarding tour
  authSessionProviderPortalTour: 'sessionInfo/provider-portal-tour',
};
